import { render, staticRenderFns } from "./ClinicianPatientOverview.vue?vue&type=template&id=aa462706"
import script from "./ClinicianPatientOverview.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports